import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ResumeManagerStore } from './resume-manager.store';

const ResumeManagerContext = React.createContext<ResumeManagerStore | null>(null);

export const ResumeManagerProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<ResumeManagerStore>(() => new ResumeManagerStore(navigate));

   return <ResumeManagerContext.Provider value={store}>{children}</ResumeManagerContext.Provider>;
};

export const useResumeManager = () => {
   const ctx = React.useContext(ResumeManagerContext);
   if (!ctx) {
      throw new Error('useResumeManager must be used inside ResumeManagerProvider');
   }

   return ctx;
};
